<!-- prettier-ignore -->
<template>
  <div class="reads-wrapper">
    <readc :authuser="authuser"></readc>
    <reads title='My Status' v-bind:reads='yourstatus' :authuser="authuser" :stories="stories"></reads>
    <reads title='Recent Updates'  v-bind:reads='recent' :authuser="authuser" :stories="stories" :activ="true" style="display:flex;"></reads>
    <reads title='Viewed Updates'  v-bind:reads='viewed' :authuser="authuser" :stories="stories" style="display:flex;"></reads>
    <div class="facebook-card" style="margin-right:10px;" v-show="$store.state.allStoryLoader">
     <vue-skeleton-loader
      type="rect"
      :width="100"
      :height="155"
      :rounded="true"
      animation="fade"
    />
    </div>
    <div class="facebook-card" style="margin-right:10px;" v-show="$store.state.allStoryLoader">
     <vue-skeleton-loader
      type="rect"
      :width="100"
      :height="155"
      :rounded="true"
      animation="fade"
    />
    </div>
    <div class="facebook-card" v-show="$store.state.allStoryLoader">
     <vue-skeleton-loader
      type="rect"
      :width="100"
      :height="155"
      :rounded="true"
      animation="fade"
    />
    </div>
    <reada></reada>
    </div>
</template>

<script>
import reads from "./reads";
import readc from "./readc";
import reada from "./readA";
import VueSkeletonLoader from "../skeletonLoader/Loader.vue";
export default {
  components: {
    reads,
    readc,
    reada,
    VueSkeletonLoader,
  },
  props: {
    authuser: {},
    stories: {},
  },
  computed: {
    recent() {
      return this.$store.getters.getRecientes || [];
    },
    viewed() {
      return this.$store.getters.getVistos || [];
    },
    yourstatus() {
      return this.$store.getters.getSilenciados || [];
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-story {
  display: flex;
  /* gap:15px; */
}
.reads-wrapper {
  display: flex;
  /* gap:10px; */
  position: relative;
  overflow: scroll;
  scrollbar-width: none;
  width: 500px;
}

.reads-wrapper::-webkit-scrollbar {
  width: 0.5rem; //only hide the vertical scrollbar
  height: 0px; //only hide the horizontal scrollbar
}
.create-story {
  box-shadow: 0px 0px 1px 1px gainsboro;
  text-align: center;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  cursor: pointer;
}
.profile-section {
  width: 80px;
  height: 70%;
}
.create-story .profile-section img {
  border-radius: 1rem 1rem 0rem 0rem;
  -webkit-border-radius: 1rem 1rem 0rem 0rem;
  -moz-border-radius: 1rem 1rem 0rem 0rem;
  -ms-border-radius: 1rem 1rem 0rem 0rem;
  -o-border-radius: 1rem 1rem 0rem 0rem;
  position: relative;
  z-index: 1;
}
.create-story p {
  font-size: 10px;
  font-weight: 600;
  color: #222;
}
.create-story span {
  font-size: 15px;
  margin-top: -10px;
  display: flex;
  align-items: center;
  border: 2px solid white;
  justify-content: center;
  background: rgb(0, 110, 255);
  position: relative;
  margin: -10px auto 0px auto;
  width: 25px;
  height: 25px;
  z-index: 2;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  color: white;
}

.open-reads {
  position: absolute;
  right: 0;
  cursor: pointer;
  top: 4rem;
}
.open-reads span {
  font-size: 23px;
  width: 30px;
  height: 32px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  color: rgb(0, 110, 255);
  background: white;
  border: 2px solid rgb(0, 110, 255);
  cursor: pointer;
}
@media (max-width: 550px) {
  .reads-wrapper {
    /* width:400px; */
    width: 100%;
    /* gap:10px; */
  }
}
@media (max-width: 450px) {
  .reads-wrapper {
    /* width:300px; */
    width: 100%;
    /* gap:10px; */
  }
}
@media (max-width: 320px) {
  .reads-wrapper {
    /* width:200px; */
    width: 100%;
  }
  .user-story {
    /* gap:10px; */
  }
}
</style>
